import { supabase } from '@/integrations/supabase/client';

export type VideoRow = {
  id: string;
  user_id?: string;
  mux_asset_id?: string | null;
  mux_playback_id?: string | null;
  playback_policy?: string | null;
  thumbnail_url?: string | null;
  title?: string | null;
  created_at?: string | null;
  updated_at?: string | null;
  status?: string | null;
  duration?: number | null;
  width?: number | null;
  height?: number | null;
  deleted_at?: string | null;
};

const tablesToTry = ['videos', 'user_videos', 'uploads', 'recordings'] as const;

export async function fetchUserVideos(userId: string, from = 0, to = 19) {
  console.log('[VID] fetch:start', { userId, from, to });

  // Try videos table first as it's the main table
  try {
    console.log('[VID] trying table: videos');
    
    const { data, error, count } = await supabase
      .from('videos')
      .select('id,user_id,mux_asset_id,mux_playback_id,playback_policy,title,created_at,updated_at,status,duration,width,height,deleted_at', { count: 'exact' })
      .eq('user_id', userId)
      .eq('status', 'ready')           // Filter by ready status instead of non-existent playback_url_ready
      .not('mux_playback_id', 'is', null)  // Ensure playback ID exists
      .is('deleted_at', null)          // Exclude soft-deleted videos
      .order('updated_at', { ascending: false })  // Order by updated_at instead of non-existent ready_at
      .range(from, to);

    if (error) {
      console.log('[VID] fetch:error', { table: 'videos', error: error.message });
      console.log('[VID] fetch:no-data - videos table failed');
      return { table: null, data: [], count: 0 };
    }
    
    if (data && data.length > 0) {
      console.log('[VID] fetch:ok', { table: 'videos', count, returned: data.length });
      return { table: 'videos', data, count: count ?? data.length };
    }
    
    console.log('[VID] fetch:empty', { table: 'videos' });
    return { table: 'videos', data: [], count: 0 };
  } catch (error) {
    console.error('[VID] fetch:error', error);
    return { table: null, data: [], count: 0 };
  }
}